import axios from "axios";


const baseUrl = `${process.env.REACT_APP_BASE_URL}/api`;

let respuesta = {};


//* Las actividades registradas son aquellas que se encuentran dentro de la vigencia de su proyecto en administracion
export const getAllFromEduconCursosRegistrados = async() => {
    const url = `${ baseUrl }/EduconCursosRegistrados`;

    await axios.get(url)
    .then((response) => {
        // respuesta.data = response.data;
        // respuesta.exito = 1;
        respuesta = { ...response.data };
    })
    .catch( 
        err => console.log( err )
    );
    return respuesta;
}